import { useState } from "react";
import { toast } from "react-toastify";
import { createDealFolder } from "../../utils/driveClient";

export default function FolderErrorBanner({ dealId, error, onResolved }) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await createDealFolder(dealId);
      toast.success("Drive folder created");
      onResolved && onResolved();
    } catch (e) {
      toast.error(`Still failing: ${e.message}`);
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="bg-red-50 border border-red-200 rounded p-4 flex items-start gap-3">
      <div className="flex-1">
        <div className="font-semibold text-red-900">Couldn't create Drive folder</div>
        <div className="text-sm text-red-700 mt-1">{error}</div>
      </div>
      <button
        onClick={handleRetry}
        disabled={retrying}
        className="bg-red-600 text-white px-3 py-1.5 rounded text-sm font-medium hover:bg-red-700 disabled:opacity-50"
      >
        {retrying ? "Retrying…" : "Retry"}
      </button>
    </div>
  );
}
